import { CollapsibleSection } from "../CollapsibleSection";

interface DevotionalFinalWordProps {
  reference: string;
  text: string;
  id?: string;
}

export const DevotionalFinalWord = ({ reference, text, id }: DevotionalFinalWordProps) => {
  return (
    <CollapsibleSection title="Final Word" id={id}>
      <p className="text-sage-600 font-medium mb-2 text-center font-serif text-lg">
        {reference}
      </p>
      <p className="font-serif text-lg leading-relaxed text-center text-justify italic">
        {text}
      </p>
    </CollapsibleSection>
  );
};